/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import useIsMobile from 'bundles/unified-common/hooks/useIsMobile';

export type SyllabusItemTitleElement = React.ReactElement<Props, typeof SyllabusItemTitle>;

type Props = {
  title: string;
  headingLevel?: 'h2';
};

const styles = {
  link: css`
    color: var(--cds-color-grey-975);

    /* doubling the current class to override CDS's blue color applied to visited links */
    &&:visited {
      color: var(--cds-color-grey-975);
    }

    &&:hover {
      color: var(--cds-color-interactive-primary);
      text-decoration: underline;
    }
  `,
  title: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
};

const SyllabusItemTitle = ({ title, headingLevel }: Props) => {
  const isMobile = useIsMobile();
  return (
    <Typography2 variant="subtitleMedium" component={headingLevel ?? 'h3'} css={!isMobile && styles.title}>
      {title}
    </Typography2>
  );
};

export default SyllabusItemTitle;
